/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';
import { SEARCH_FILTER_INVENTORY_VALUES } from 'site-kit';

import { FiltersTypeProps } from '../../../types/filters';
import { toggleFilterGroups } from '../../../utils/filters';
import { INVENTORY_TYPES_FILTERS } from '../../../constants/filters/inventoryTypes';
import { CommonFilter } from './CommonFilter';

interface InventoryTypeFiltersProps {
    /** Selected filter groups */
    fg: string[];
    onFilterGroupsChange: (fg: string[]) => void;
}

const filters: FiltersTypeProps[] = SEARCH_FILTER_INVENTORY_VALUES.flatMap((item) => {
    const current = INVENTORY_TYPES_FILTERS.find((value) => value.legacyKey === item.key);
    return current
        ? [
              {
                  value: current.value,
                  key: current.key,
                  legacyKey: current.legacyKey || '',
                  icon: item.icon,
              },
          ]
        : [];
});

/** Booking type checkboxes */
export function InventoryTypeFilters({
    fg,
    onFilterGroupsChange,
}: InventoryTypeFiltersProps) {
    const onChange = React.useCallback(
        (_event: React.ChangeEvent<HTMLInputElement>, item: FiltersTypeProps) => {
            onFilterGroupsChange(toggleFilterGroups(item, { fg }));
        },
        [fg, onFilterGroupsChange]
    );

    return (
        <CommonFilter
            fg={fg}
            filters={filters}
            title="Booking Types"
            onChange={onChange}
            hasDivider={false}
            headingLevel={2}
        />
    );
}
